import Button from '@atomaro/ui-kit/components/Button/Button/Button';
import {COLORS} from '../../consts';

interface AbsenceTextProps {
  text: string;
  subText?: string;
  onClick?: () => void;
  buttonText?: string;
  isBtnVisible?: boolean;
}

export const AbsenceText = (props: AbsenceTextProps) => {
  const {text, buttonText = 'Добавить', isBtnVisible = true, onClick, subText} = props;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '16px',
        padding: '100px',
      }}
    >
      <p style={{color: COLORS.FG.DEFAULT, fontSize: 18, fontWeight: 'bold'}}>{text}</p>
      {subText && <p style={{color: COLORS.FG.SOFT, fontSize: 16}}>{subText}</p>}
      {isBtnVisible && <Button label={buttonText} onClick={onClick} />}
    </div>
  );
};
